import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '.';

export interface SimulationResultPayload {
  success: boolean;
  crmOrgId?: string;
  tracedUserId?: string;
  error?: string;
}

export interface SimulationState {
  lastSimulationResult: SimulationResultPayload | null;
}

const initialState: SimulationState = {
  lastSimulationResult: null,
};

const simulationSlice = createSlice({
  name: 'simulation',
  initialState,
  reducers: {
    setSimulationResult: (state, action: PayloadAction<SimulationResultPayload>) => {
      state.lastSimulationResult = action.payload;
    },
    clearSimulationResult: (state) => {
      state.lastSimulationResult = null;
    },
  },
});

export const { setSimulationResult, clearSimulationResult } = simulationSlice.actions;

export const selectLastSimulationResult = (state: RootState) =>
  state.simulation.lastSimulationResult;

export default simulationSlice.reducer;
